// src/services/WebSocketService.js
import auth from 'services/login/auth';
import { 
  LOGGEDIN_USER_DATA
} from 'global_config/constant-global';

class WebSocketService {
  static instance = null;
  socket = null;
  listeners = new Set();
  url = null;
  reconnectInterval = 3000; 
  shouldReconnect = true;
  clientId = null; 

  static getInstance() {
    if (!WebSocketService.instance) {
      WebSocketService.instance = new WebSocketService();
    }
    return WebSocketService.instance;
  }

  connect(url) {
    this.url = url;

    if (this.socket) return; 

    console.log("Connecting to WebSocket:", url);
    this.socket = new WebSocket(url);

    this.socket.onopen = () => {
      console.log("WebSocket connected");
    };

    this.socket.onmessage = (event) => {
      let message;
      try {
        message = JSON.parse(event.data);
      } catch (e) {
        message = event.data;
      }

      if (message.FUNCTION === "CONNECT" && message.CLIENT_ID) {
        this.clientId = message.CLIENT_ID;
        console.log("Handshake received, sending ACK...", this.clientId);
        sessionStorage.setItem("clientId", this.clientId);
        this.sendMessage({
          FUNCTION: "ACK-CONNECT",
          CLIENT_ID: this.clientId,
        });
      }

      try {
        const loggedInData = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA) || "{}");
        const currentUsername = loggedInData.userName || loggedInData.USERNAME;

        if (
          message.MODULE === "LOGIN" &&
          message.EVENT === "LOGIN_OK" &&
          message.SENDTO === sessionStorage.getItem("clientId") &&
          Array.isArray(message.VALUES) &&
          message.VALUES.length > 0 &&
          message.VALUES[0].USERNAME === currentUsername
        ) {
          console.warn("⚠️ Matching EVENT OK for this user detected. Signing out...");
          auth.signout();
        } else {
          console.log("CLIENTID: " + (sessionStorage.getItem("clientId") === message.SENDTO));
          console.log("ISARRAY: " + Array.isArray(message.VALUES));
          console.log("currentUsername: " + (currentUsername === message.VALUES[0].USERNAME));
          console.log("MODULE: " + (message.MODULE === "LOGIN"));
          console.log("EVENT: " + (message.EVENT === "LOGIN_OK"));
          console.log("LEN: " + (message.VALUES.length > 0));
        }
        
      } catch (e) {
        console.error("Error checking signout condition:", e);
      }

      this.listeners.forEach((cb) => cb(message));
    };

    this.socket.onclose = () => {
      console.log("WebSocket closed");
      this.socket = null;

      this.listeners.forEach((cb) => cb({ FUNCTION: "DISCONNECTED" }));

      if (this.shouldReconnect) {
        this.listeners.forEach((cb) => cb({ FUNCTION: "RECONNECTING" }));

        setTimeout(() => {
          console.log("Reconnecting...");
          this.connect(this.url);
        }, this.reconnectInterval);
      }
    };

    this.socket.onerror = (error) => {
      console.error("WebSocket error", error);
      this.socket.close();
    };
  }

  sendMessage(data) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(data));
    } else {
      console.warn("WebSocket not connected. Message not sent:", data);
    }
  }

  getClientId() {
    return this.clientId || sessionStorage.getItem("clientId");
  }

  subscribe(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  disconnect() {
    this.shouldReconnect = false;
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
    this.clientId = null;
    sessionStorage.removeItem("clientId");
  }

  reconnect(url) {
    this.disconnect();
    this.shouldReconnect = true;
    this.connect(url || this.url);
  }
}

export default WebSocketService.getInstance();
